import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({
  name: 'isControlRequired'
})
export class IsControlRequiredPipe implements PipeTransform {
  transform(control: AbstractControl): boolean {
    if (!control.validator) {
      return false;
    }

    const validator = control.validator({} as AbstractControl);
    return validator && validator.required;
  }
}
